(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dh-listicle-product"] && !Shopify.designMode) return;
  try {
    
  const setupListiclePackPrice = () => {
    document.querySelectorAll('.dh-listicle-product').forEach(root => {
      if (root.dataset.priceReady) return;
      root.dataset.priceReady = 'true';
      const sync = () => {
        const selected = root.querySelector('.kaching-bundles__bar--selected');
        if (!selected) return;
        const price = selected.querySelector('.kaching-bundles__bar-price')?.textContent.trim();
        const compare = selected.querySelector('.kaching-bundles__bar-full-price')?.textContent.trim() || '';
        const currentNode = root.querySelector('[data-dh-listicle-price]');
        const compareNode = root.querySelector('[data-dh-listicle-compare]');
        if (price && currentNode.textContent !== price) currentNode.textContent = price;
        if (compareNode.textContent !== compare) compareNode.textContent = compare;
        compareNode.hidden = !compare;
      };
      const observer = new MutationObserver(sync);
      observer.observe(root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class']});
      sync();
    });
  };
  setupListiclePackPrice();
  document.addEventListener('shopify:section:load', setupListiclePackPrice);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dh-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dh-review-carousel')) {
  customElements.define('dh-review-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dh-review-track');
      if (!this.track) return;
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.refresh = () => {
        const limit = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= limit - 2;
      };
      this.onClick = event => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const card = this.track.querySelector('.dh-review-card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 20;
        const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        this.track.scrollBy({left:step * Number(button.dataset.direction),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      this.addEventListener('click',this.onClick);
      this.track.addEventListener('scroll',this.refresh,{passive:true});
      this.observer = new ResizeObserver(this.refresh);
      this.observer.observe(this.track);
      this.refresh();
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.onClick);
      this.track?.removeEventListener('scroll',this.refresh);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
